﻿import React from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';

import Accordion from '../../../UI/Accordion';
import HealthDeclarationHeading from './HealthDeclarationHeading';

import DynamicFormQuestionGroup from '../../../DynamicForms/Components/DynamicFormQuestionGroup';
import HealthDeclarationQuestionTypeHandler from './HealthDeclarationQuestionTypeHandler';

import definitions from '../../../Style/LfStyleDefinitions';

import {
    registerVirtualPageViewAction,
    addQuestionGroupsQuestionsAction,
    repeatQuestionGroupAction,
    removeRepeatedQuestionGroupAction,
    removeQuestionGroupsQuestionsAction
} from '../State/actions';

class HealthDeclarationStepTwo extends React.Component {
    componentDidMount() {
        this.props.registerVirtualPageView();
    }

    render() {
        const healthFormData = this.props.data.healthFormData;

        return (
            <div>
                <Accordion
                    title={<HealthDeclarationHeading/>}
                    unexpandable={true}
                    noHeaderPadding={true}
                    headerComponent={
                        <HealthDeclarationConfirmation>
                            {healthFormData.questionGroups.map(group => (
                                <DynamicFormQuestionGroup
                                    key={group.id}
                                    questionGroup={group}
                                    questionTypeHandler={HealthDeclarationQuestionTypeHandler}

                                    formInputs={this.props.formInputs}
                                    repeatedInputs={this.props.repeatedInputs}

                                    removeRepeatedQuestionGroup={this.props.removeRepeatedQuestionGroup}
                                    repeatQuestionGroup={this.props.repeatQuestionGroup}
                                    addQuestionGroupInputs={this.props.addQuestionGroupInputs}
                                    removeQuestionGroupInputs={this.props.removeQuestionGroupInputs}
                                />
                            ))}
                        </HealthDeclarationConfirmation>
                    }
                >
                </Accordion>
            </div>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.healthDeclarationPageData,
        currentStep: state.pageCurrentStep,
        formInputs: state.healthDeclarationFormInputs,
        repeatedInputs: state.healthDeclarationRepeatedInputs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        registerVirtualPageView: () => dispatch(registerVirtualPageViewAction()),
        addQuestionGroupInputs: (...args) => dispatch(addQuestionGroupsQuestionsAction(...args)),
        removeRepeatedQuestionGroup: (questionGroup, index) => dispatch(removeRepeatedQuestionGroupAction(questionGroup, index)),
        repeatQuestionGroup: (questionGroup) => dispatch(repeatQuestionGroupAction(questionGroup)),
        removeQuestionGroupInputs: (...args) => dispatch(removeQuestionGroupsQuestionsAction(...args))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthDeclarationStepTwo);

// styles

const HealthDeclarationConfirmation = styled.div`
    background-color: ${definitions.colors.blueBackground};
`;
